<template>
  <div v-if="scope.time.length>=2">
    <div>
      <div class="flex-container">
        <span class="name-right">
        {{ scope.time[0].name }}
          :
        </span>
        <span v-if="scope.record[scope.time[0].time]" class="time-left">
          {{hashTime(scope.time[0].time,scope.record)}}
        </span>
        <el-tooltip content="折叠更多" v-if="showToolTip[scope.index]">
          <i class="el-icon-caret-top iconMore" @click="openMore(scope.index)">折叠更多</i>
        </el-tooltip>
        <el-tooltip content="展开更多" v-if="!showToolTip[scope.index]">
          <i class="el-icon-caret-bottom iconMore" @click="openMore(scope.index)">展开更多</i>
        </el-tooltip>
      </div>
      <div v-for="(con,index1) in scope.time" :key="index1" v-if="showToolTip[scope.index]">
        <br v-if="index1 !== 0">
        <div v-if="index1 !== 0" class="flex-container">
          <span class="name-right">
            <span>{{ con.name }}：</span>
          </span>
          <span v-if="scope.record[con.time]" class="time-left">{{hashTime(con.time,scope.record)}}</span>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
   {{ scope.time[0].name }}:{{scope.record[scope.time[0].time]}}
  </div>
</template>

<script>
export default {
  name: "ExFoldLine",
  props: ['scope',],
  data() {
    return {
      showToolTip: [],
    }
  },
  methods: {
    hashTime(time,record){
      if (time.includes('.')) {
        const keys = time.split('.');
        return keys.reduce((obj, key) => obj && obj[key], record);
      }
      return record[time]
    },
    openMore(index) {
      this.$set(this.showToolTip, index, !this.showToolTip[index]);
    }
  }
}
</script>

<style scoped>
.iconMore {
  color: #4eaad4;
  cursor: pointer;
}
.flex-container {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  max-width: 600px; /* 根据需要调整最大宽度 */
  margin: 0 auto; /* 居中整个容器 */
}

.name-right {
  text-align: right; /* 右对齐名称部分 */
  min-width: 100px; /* 最小宽度，防止名称过短时布局错乱 */
  max-width: 200px; /* 最大宽度，防止名称过长时占据过多空间 */
  margin-right: 10px; /* 可选：添加右侧间距 */
}

.time-left {
  text-align: left; /* 左对齐时间部分 */
}
</style>
